module.exports = __webpack_public_path__ + "static/media/media.9efa1d3a.png";